module.exports = __webpack_public_path__ + "static/media/Rectangle57.cf5b3b10.png";